import { render } from "./aio-login-hcaptcha-popup.vue?vue&type=template&id=d009e982&scoped=true"
import script from "./aio-login-hcaptcha-popup.vue?vue&type=script&lang=js"
export * from "./aio-login-hcaptcha-popup.vue?vue&type=script&lang=js"

import "./aio-login-hcaptcha-popup.vue?vue&type=style&index=0&id=d009e982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d009e982"]])

export default __exports__